var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPycharmJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V70H70V0H0Z",
    fill: "url(#paint0_linear_4_11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 60.4H60.4V9.5H9.5V60.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.978 54.128H15.886V50.9474H34.978V54.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4051 25.646C25.5029 25.646 26.7301 24.3926 26.7301 22.7585V22.7038C26.7301 20.8247 25.422 19.8163 23.3242 19.8163H20.0823V25.646L23.4051 25.646ZM15.8867 16.0298H23.6786C28.2264 16.0298 30.9783 18.727 30.9783 22.6207V22.6776C30.9783 27.0876 27.5461 29.3757 23.2695 29.3757H20.0823V35.096H15.8867V16.0298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2341 16.067V19.7748H38.0361V23.7167H47.077V27.4245H38.0361V31.3664H48.4661V35.0742H33.8621V16.0672L48.2341 16.067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_11",
    x1: 69.023,
    y1: 69.026,
    x2: -18.158,
    y2: -18.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48199,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72582,
    stopColor: "#FCF84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF84A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPycharmJob);
export default __webpack_public_path__ + "static/media/pycharm-job.248a7706791288e94751fc1e75d3d57f.svg";
export { ForwardRef as ReactComponent };